import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { removeCart } from 'b2b-apps/shop/cart/redux/cart/actionCreators';

type UseRemoveCartActionReturnType = typeof removeCart;

const useRemoveCartAction = (): UseRemoveCartActionReturnType => {
  const dispatch = useDispatch();

  return useMemo(
    () => bindActionCreators(removeCart, dispatch),
    [dispatch],
  );
};

export type { UseRemoveCartActionReturnType };
export { useRemoveCartAction };
